import { getIn } from "formik";
import React from "react";

import { Text, TextArea, TextColors, TextTypes } from "../../../component-library";

import "./styles.scss";

// NOTE: THIS PATTERN WAS COPIED FROM the care management form
export const WaitlistFormField = ({ formikProps, name }) => {
  const errorMessage = getIn(formikProps.errors, name);
  const isTouched = getIn(formikProps.touched, name);

  const handleChange = async (event) => {
    await formikProps.setFieldValue(name, event.target.value);
  };

  return (
    <>
      <TextArea
        classes="large"
        className="WaitlistPage--comment-text-area w-100"
        ignoreEnterSubmit={true}
        onChange={handleChange}
        spanClasses="w-100"
      />
      {errorMessage && isTouched && (
        <Text className="pt-2" color={TextColors.red} type={TextTypes.small}>
          {errorMessage}
        </Text>
      )}
    </>
  );
};
